import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  genders: []
}

// getters
export const getters = {
  genders: state => state.genders
}

// mutations
export const mutations = {
  [types.FETCH_GENDERS_SUCCESS] (state, { genders }) {
    state.genders = genders
  },

  [types.FETCH_GENDERS_FAILURE] (state) {
    state.GENDERS = []
  }
}

// actions
export const actions = {
  async fetchGenders ({ commit }) {
    try {
      const response = await axios.get(`/api/genders`)

      commit(types.FETCH_GENDERS_SUCCESS, { genders: response.data })
    } catch (error) {
      console.error(error)
      commit(types.FETCH_GENDERS_FAILURE)
    }
  }
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/genders.js